import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-divider',
  templateUrl: './divider.html',
  styleUrl: './divider.css',
})
export class Divider {
  public readonly text = input<string>('');
}
